import { render, staticRenderFns } from "./DeliveryScheduling.vue?vue&type=template&id=1bf49da0&scoped=true&"
import script from "./DeliveryScheduling.vue?vue&type=script&lang=js&"
export * from "./DeliveryScheduling.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryScheduling.vue?vue&type=style&index=0&id=1bf49da0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf49da0",
  null
  
)

export default component.exports